import {component} from '@reduct/component';
import propTypes from '@reduct/nitpick';

@component({
    productIdentifier: propTypes.string.isRequired,
    translations: propTypes.object.isRequired,
})
export default class ProductItem {
    button;
    currentProductItem;
    allProductItems;

    constructor() {
        this.button = this.el.querySelector('button');
        this.button.addEventListener('click', e => this.selectProduct(e));

        this.el.addEventListener('click', e => this.selectProduct(e));

        this.allProductItems = this.el.parentNode.parentNode.parentNode.querySelectorAll('.product-item');

        const lastSaleSpan = this.el.querySelector('.last-sale span');

        this.allProductItems.forEach((item, index) => {
            if (this.el === item) {
                if (index === 0) {
                    lastSaleSpan.innerText = this.getRandomInteger(10, 24) + ' ' + this.props.translations.lastSaleHours;
                }
                if (index === 1) {
                    lastSaleSpan.innerText = this.getRandomInteger(2, 35) + ' ' + this.props.translations.lastSaleSeconds;
                }
                if (index === 2) {
                    lastSaleSpan.innerText = this.getRandomInteger(3, 60) + ' ' + this.props.translations.lastSaleMins;
                }

                this.currentProductItem = index;
            }
        });
    }

    selectProduct() {
        let currentSelectedProductItem = document.querySelector('.product-item-selected');
        currentSelectedProductItem.classList.remove('product-item-selected');

        this.allProductItems[this.currentProductItem].classList.add('product-item-selected');

        this.allProductItems.forEach((item) => {
            item.querySelector('.btn').innerText = this.props.translations.selectProduct;
        });

        this.button.innerText = this.props.translations.productSelected;

        let productIdentifierInput = document.getElementById('product');
        productIdentifierInput.value = this.props.productIdentifier;

        $('html, body').animate({
            scrollTop: $('#checkout-form').offset().top
        }, 500);
    }

    getRandomInteger(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
    }
}

